module.exports = __webpack_public_path__ + "static/media/bulb-orange.a4b7fa02.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/new-images/bulb-orange.svg
// module id = 317
// module chunks = 0